import { ROUTES } from '@app/AppRoutes/routes';
import { TPathOptions } from '@app/types/types';

const MagicLinkPathOptions: TPathOptions = {
	external: true,
	path: ROUTES.MAGIC_LINK.path,
};

export default MagicLinkPathOptions;
